import React from 'react';
import PadraoInfoButton from './PadraoInfoButton';

const PatternPriceTable = ({ color, title, padroes, onShowPadraoInfo }) => (
    <table className="table table-striped table-condensed" style={{ border: `3px solid ${color}` }}>
        <thead>
            <tr className="text-center" style={{ backgroundColor: color, color: '#fff' }}>
                <td colSpan={3} style={{ textTransform: 'uppercase', padding: 6 }}>
                    Preço Médio Por Padrão - {title}
                </td>
            </tr>
            <tr className="text-center" style={{ backgroundColor: color, color: '#fff', textTransform: 'uppercase' }}>
                <th className="text-center" style={{ color: '#fff', paddingTop: 3, paddingBottom: 3 }}>
                    Padrão
                    <PadraoInfoButton title={title} color={color} onShow={onShowPadraoInfo} />
                </th>
                <th className="text-center" style={{ color: '#fff', paddingTop: 3, paddingBottom: 3 }}>Preço Médio</th>
                <th className="text-center" style={{ color: '#fff', paddingTop: 3, paddingBottom: 3 }}>Preço Médio m²</th>
            </tr>
        </thead>
        <tbody>
            {padroes.map((p, i) => (
                <tr className="text-center" key={i}>
                    <td>{p.padrao}</td>
                    <td>{p.preco_medio}</td>
                    <td>{p.preco_medio_metro}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default PatternPriceTable;
